export interface InvoiceSettings {
  stripeInvoice: any;
  pollingStatus: 'running' | 'stop';
}
export default {
  pollingStatus: 'stop',
} as InvoiceSettings;

export const spaceName = 'caOrderInvoice';
